import { createSlice } from '@reduxjs/toolkit';
import { ProductStockTransfersDetailStateType } from 'src/types/productStockTransfersDetail';

const initialState: ProductStockTransfersDetailStateType = {
    data: null,
    loading: false,
    error: false,
};
export const productStockTransfersDetailSlice = createSlice({
    name: 'productStockTransfersDetail',
    initialState,
    reducers: {
        getProductStockTransfersDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductStockTransfersDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getProductStockTransfersDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearProductStockTransfersDetail: () => initialState,
    },
});

export const {
    getProductStockTransfersDetailFetch,
    getProductStockTransfersDetailFetchSuccess,
    getProductStockTransfersDetailFetchFailure,
    clearProductStockTransfersDetail,
} = productStockTransfersDetailSlice.actions;

export default productStockTransfersDetailSlice.reducer;
